import React, { useState, useEffect, useCallback } from "react";
import { CSVLink } from "react-csv";
import styles from "./CSVDownloadButton.module.css"; // Import your CSS styles
import { api } from "../../config/apis";

function CSVDownloadButton({
  apiEndpoint,
  params,
  variant,
  fileName,
  data,
  reRender,
  downloadText,
  headers,
  filters,
  // Same shape as the grid's `filters` prop. Sent as `filters[key]=value` so the
  // CSV endpoint receives the exact filters the grid is currently showing.
  nestedFilters,
}) {
  // Data fetched internally when the caller only provides an apiEndpoint.
  const [fetchedData, setFetchedData] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get(apiEndpoint, {
        params: {
          sort_order: params,
          ...filters,
          ...(nestedFilters ? { filters: nestedFilters } : {}),
          download_csv: true,
        },
      });
      setFetchedData(response.data.data ?? []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiEndpoint, params, filters, nestedFilters]);

  useEffect(() => {
    // Only self-fetch when no data is passed down from the parent.
    if (!data && apiEndpoint) {
      fetchData();
    }
  }, [fetchData, data, reRender, apiEndpoint]);

  // When the parent supplies `data`, use it directly so the download always
  // reflects the current (e.g. filtered) data instead of a stale copy.
  const csvData = data ?? fetchedData;

  return (
    <CSVLink
      className={`${styles.filter_btna} ${
        variant ? styles.filter_btna_black : ""
      }`}
      data={csvData ?? ""}
      filename={fileName ?? "grid_data"}
      headers={headers}
    >
      {downloadText ? downloadText : "Download CSV"}
    </CSVLink>
  );
}

export default CSVDownloadButton;
